var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialfacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5ZM10.4704 17.985V12.7879H8.7002V10.8977H10.4704V9.63973C10.4704 7.55715 11.4798 6.64322 13.2017 6.64322C14.0031 6.64322 14.4378 6.70151 14.651 6.7301C14.6572 6.73093 14.6632 6.73174 14.6691 6.73251V8.38239H13.4945C12.7635 8.38239 12.5083 9.07938 12.5083 9.86446V10.8977H14.6506L14.3602 12.7879H12.5083V17.985H10.4704Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialfacebook);
export default __webpack_public_path__ + "static/media/Social facebook.522b4d9c6b48c9e95167dfb1fce8e031.svg";
export { ForwardRef as ReactComponent };